import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

type AddAttachment = {
  gstrNoticeOrderId: number;
  data: FormData;
};

const getOrderNotices = ({ queryKey }: any) => {
  return http.get(`/gstr/order-notices/${queryKey[1]}`, { params: { ...queryKey[2] } });
};
const gstClientNoticeandordersExport = (data: any) => {
  return cronHttp.post("/gstr/export-gstr-clientnotices", data);
};

const getGstrAdditional = ({ queryKey }: any) => {
  return http.get(`/gstr/additional/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const exportreferenceBasedNotices = (data: any) => {
  return cronHttp.post("/gstr/export-referencenotices", data);
};

const getGstrAdditionalNotice = ({ queryKey }: any) => {
  return http.get(`/gstr/additional-notice/${queryKey[1]}`);
};

const getOrderNotice = ({ queryKey }: any) => {
  return http.get(`/gstr/order-notice/${queryKey[1]}`);
};

const getGstrProfile = ({ queryKey }: any) => {
  return http.get(`/gstr/gstr-profile/${queryKey[1]}`);
};

const getAdditionalDocs = ({ querykey }: any) => {
  return http.post(`/gstr/gstr-docs/${querykey[1]}`, { ...querykey[0] });
};

const getGstrClientCompliance = ({ queryKey }: any) => {
  return http.get(`gstr/gstr-compliance/${queryKey[1]}`);
};

const getAddNoticeAndOrders = ({ queryKey }: any) => {
  return http.get("/gstr/gstr-add", { params: { ...queryKey[1] } });
};
const exportAdditionalGstNoticeAndOrders = (data: any) => {
  return cronHttp.post("/gstr/export-gstr-add", data);
};

const getNoticeAndOrders = ({ queryKey }: any) => {
  return http.get("/gstr/gstr-notices-orders", { params: { ...queryKey[1] } });
};

const exportGstNoticeAndOrders = (data: any) => {
  return cronHttp.post("/gstr/export-gstr-notices-orders", data);
};

const getGstrReports = ({ queryKey }: any) => {
  return http.get(`/gstr/reports`, { params: { ...queryKey[1] } });
};

const exportGstSyncReports = (data: any) => {
  return cronHttp.post(`/gstr/export-reports`, data);
};

const getNoticeAndOrderDueDateEvents = ({ queryKey }) => {
  return http.get("gstr/notice-and-order-dueDate-events", { params: { ...queryKey[1] } });
};

const getNoticeAndOrderIssueDateEvents = ({ queryKey }) => {
  return http.get("gstr/notice-and-order-issue-events", { params: { ...queryKey[1] } });
};

const getAddNoticeIssueDateEvents = ({ queryKey }) => {
  return http.get("gstr/add-notice-issue-events", { params: { ...queryKey[1] } });
};

const getAddNoticeDueDateEvents = ({ queryKey }) => {
  return http.get("gstr/add-notice-dueDate-events", { params: { ...queryKey[1] } });
};

const getGstrNewUpdates = ({ queryKey }: any) => {
  return http.get(`/gstr/new-updates`, { params: { ...queryKey[1] } });
};

const getGstrNewUpdateItem = ({ queryKey }: any) => {
  return http.get(`/gstr/update/${queryKey[1]}`);
};

const organizationGstrScheduling = () => {
  return http.get(`/gstr/scheduling`);
};

const getGstrCaseIdNotices = ({ queryKey }: any) => {
  return http.get(`/gstr-client/case-id/${queryKey[1]}`, { params: { ...queryKey[2] } });
};
const exportCaseBasedNotices = (data: any) => {
  return cronHttp.post("/gstr-client/export-casenotices", data);
};

const addNoticeAndOrderAttachment = ({ gstrNoticeOrderId, data }: AddAttachment) => {
  return http.post(`/gstr/${gstrNoticeOrderId}/attachments`, data);
};

const manualAttachmentsDelete = ({ id, gstrId }) => {
  return http.delete(`/gstr/remove-file/${id}`,
    {
      params: { gstrId }
    }
  );
};

const getGstDemands = ({ queryKey }: any) => {
  return http.get("/gstr/demands", { params: { ...queryKey[1] } })
}

const getClientDemands = ({ queryKey }: any) => {
  return http.get(`/gstr/demand/${queryKey[1]}`, { params: { ...queryKey[2] } });
}

const getGstLedgers = ({ queryKey }: any) => {
  return http.get(`/gstr/ledgers`, { params: { ...queryKey[1] } });
}

const getClientLedgers = ({ queryKey }: any) => {
  return http.get(`gstr/ledger/${queryKey[1]}`, { params: { ...queryKey[2] } });
}

const exportGstDemands = (data: any) => {
  return cronHttp.post("/gstr/demands-export", data);
};

const exportGstLedgers = (data: any) => {
  return cronHttp.post("/gstr/ledgers-export", data);
};

const exportclientDemand = (data: any) => {
  return cronHttp.post("/gstr/export-clientdemand", data);
};

const exportclientLedger = (data: any) => {
  return cronHttp.post("/gstr/export-clientledger", data);
};

const getCaseTypeNames = () => {
  return http.get("/gstr/case-type-name")
}

const getCaseFolderTypeNames = () => {
  return http.get("/gstr/case-folder-type-name")
}

const updateCustomDueDate = (data: any) => {
  return http.post("/gstr/custom-due-date", data);
};

const getCustomDueDateEvents = ({ queryKey }) => {
  return http.get("gstr/custom-dueDate-events", { params: { ...queryKey[1] } });
};


export {
  exportCaseBasedNotices,
  exportreferenceBasedNotices,
  gstClientNoticeandordersExport,
  exportGstSyncReports,
  exportAdditionalGstNoticeAndOrders,
  getOrderNotices,
  exportGstNoticeAndOrders,
  getGstrAdditional,
  getOrderNotice,
  getGstrAdditionalNotice,
  getGstrProfile,
  getAdditionalDocs,
  getGstrClientCompliance,
  getAddNoticeAndOrders,
  getNoticeAndOrders,
  getGstrReports,
  getNoticeAndOrderDueDateEvents,
  getNoticeAndOrderIssueDateEvents,
  getAddNoticeIssueDateEvents,
  getAddNoticeDueDateEvents,
  getGstrNewUpdates,
  getGstrNewUpdateItem,
  organizationGstrScheduling,
  getGstrCaseIdNotices,
  addNoticeAndOrderAttachment,
  getGstDemands,
  getClientDemands,
  getGstLedgers,
  getClientLedgers,
  exportGstDemands,
  exportGstLedgers,
  exportclientDemand,
  exportclientLedger,
  getCaseTypeNames,
  getCaseFolderTypeNames,
  manualAttachmentsDelete,
  updateCustomDueDate,
  getCustomDueDateEvents
};
